import { useStaffMode } from "../../../hooks/StaffModeProvider";

const Bell = (props: any) => {
  const { isStaffMode } = useStaffMode();

  return (
    <svg
      width="21"
      height="27"
      viewBox="0 0 21 27"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M0.666748 22.514V20.5143H3.07708V10.5653C3.07708 8.77219 3.63053 7.18675 4.73741 5.80897C5.84408 4.43119 7.26497 3.54997 9.00008 3.1653V2.33464C9.00008 1.87175 9.16197 1.47819 9.48575 1.15397C9.80953 0.829969 10.2026 0.667969 10.6651 0.667969C11.1277 0.667969 11.5214 0.829969 11.8461 1.15397C12.171 1.47819 12.3334 1.87175 12.3334 2.33464V3.1653C14.0685 3.54997 15.4894 4.43119 16.5961 5.80897C17.703 7.18675 18.2564 8.77219 18.2564 10.5653V20.5143H20.6667V22.514H0.666748ZM10.6644 26.2576C10.0011 26.2576 9.43397 26.0216 8.96308 25.5496C8.49197 25.0776 8.25642 24.5102 8.25642 23.8473H13.0771C13.0771 24.5124 12.8409 25.0804 12.3684 25.5513C11.896 26.0222 11.328 26.2576 10.6644 26.2576ZM5.07708 20.5143H16.2564V10.5653C16.2564 9.02175 15.7107 7.7043 14.6194 6.61297C13.5279 5.52141 12.2103 4.97564 10.6667 4.97564C9.12319 4.97564 7.80564 5.52141 6.71408 6.61297C5.62275 7.7043 5.07708 9.02175 5.07708 10.5653V20.5143Z"
      />
      {true && (
        <circle cx="17" cy="4" r="4" fill={isStaffMode ? '#0070CD' :'#BC3323'} />
      )}
    </svg>
  );
};

export default Bell;